import useSWR from "swr";


export const useFetchSignUpAuthCode = () => {
  const { data: signUpAuthCode, error, isLoading } = useSWR<string>('kuitan/signup/auth-code/')
  return { signUpAuthCode, isLoading, error };
};